import React, { Component } from "react";
import { Accordion, Card, useAccordionButton } from "react-bootstrap";
import ApiConnect from "../../../../../Utils/ApiConnect";
import { toast } from "react-toastify";
function CustomToggle({ children, eventKey }) {
  const decoratedOnClick = useAccordionButton(eventKey);
  return (
    <div className="row w-100" onClick={decoratedOnClick}>
      {children}
    </div>
  );
}
export default class NewRoles extends Component {
  constructor() {
    super();
    this.state = {
      menusData: [],
      role_name: "",
      permission: [],
      dashboard: [],
      defaultDash: "",
      edit: 0,
      delete: 0,
      post: 0,
      view: 0,
      approve: 0,
      print: 0,
      export: 0,
      isRoot: 0,
      Authlevel: 1,
      formError: false,
      btnDisable: false,
    };
  }
  componentDidMount = () => {
    ApiConnect.get("/Dashboard/UserPermission/MenuPermission")
      .then((response) => {
        this.setState({
          menusData: response.data,
        });
      })
      .catch((error) => console.error(error));
  };
  handleChangePermission = (menu, submenu, e) => {
    const permission = this.state.permission.slice();
    let newData = `${menu},${submenu}`;
    if (e.target.checked) {
      const findPermission = permission.find((items) => items === newData);
      if (!findPermission) {
        permission.push(newData);
      }
    } else {
      const findPermission = permission.find((items) => items === newData);
      const index = permission.indexOf(findPermission);
      permission.splice(index, 1);
    }
    this.setState({ permission: permission });
  };
  handleChange = (e) => {
    const newData = { ...this.state };
    if (
      e.target.type === "checkbox" ||
      (e.target.type === "radio" && e.target.checked)
    ) {
      if (
        (e.target.name === "dashboard" && this.state.defaultDash === "") ||
        this.state.defaultDash === false
      ) {
        newData["defaultDash"] = e.target.value;
      }
      if (e.target.name === "dashboard") {
        const oldDash = this.state.dashboard.slice();
        oldDash.push(e.target.value);
        newData[e.target.name] = oldDash;
      } else {
        newData[e.target.name] = e.target.value;
      }
    } else if (
      e.target.type === "checkbox" ||
      (e.target.type === "radio" && !e.target.checked)
    ) {
      if (e.target.name === "dashboard") {
        const oldDash = this.state.dashboard.slice();
        const findDash = oldDash.find((items) => items === e.target.value);
        const index = oldDash.indexOf(findDash);
        oldDash.splice(index, 1);
        newData[e.target.name] = oldDash;
      } else {
        newData[e.target.name] = 0;
      }
    } else {
      newData[e.target.name] = e.target.value;
    }
    this.setState(newData);
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ btnDisable: true });
    let formData = new FormData();
    this.state.dashboard.forEach((dash) => {
      formData.append("dashboard[]", dash);
    });
    formData.append("defaultDash", this.state.defaultDash);
    formData.append("edit", this.state.edit);
    formData.append("delete", this.state.delete);
    formData.append("post", this.state.post);
    formData.append("view", this.state.view);
    formData.append("approve", this.state.approve);
    formData.append("print", this.state.print);
    formData.append("export", this.state.export);
    formData.append("isRoot", this.state.isRoot);
    formData.append("Authlevel", this.state.Authlevel);
    this.state.permission.forEach((x) => {
      formData.append("permission[]", x);
      console.log(x);
    });
    formData.append("name", this.state.role_name);
    ApiConnect({
      method: "post",
      url: "/Module/Utilities/Users/NewRole",
      data: formData,
    })
      .then((response) => {
        if (response.data.status === 201) {
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.setState({
            role_name: "",
            permission: [],
            dashboard: [],
            defaultDash: "",
            edit: 0,
            delete: 0,
            post: 0,
            view: 0,
            approve: 0,
            print: 0,
            export: 0,
            isRoot: 0,
            Authlevel: 1,
            formError: false,
            btnDisable: false,
          });
        } else {
          this.setState({ formError: response.data.message });
        }
      })
      .catch((error) => console.log(error));
  };
  render() {
    const menuDatas = this.state.menusData;
    console.log(this.state.permission);
    return (
      <div className="col-md-12 col-xl-12">
        <form onSubmit={(e) => this.handleSubmit(e)}>
          <p className="text-danger">{this.state.formError}</p>
          <div className=" ">
            <div className="form-group row py-1">
              <label className="col-4 col-lg-2 col-form-label">Role Name</label>
              <div className="col-8 col-lg-10">
                <input
                  type="text"
                  className="form-control "
                  name="role_name"
                  required
                  value={this.state.role_name}
                  onChange={(e) => this.handleChange(e)}
                />
              </div>
            </div>
            <div className="form-group row py-1 col-12">
              <div className="col-6">
                <label className="col-4 col-form-label">Is Root</label>
                <div className="col-8 col-lg-10">
                  <input
                    type="checkbox"
                    name="isRoot"
                    value={1}
                    checked={this.state.isRoot ? true : false}
                    onChange={(e) => this.handleChange(e)}
                  />
                </div>
              </div>
              <div className="col-6">
                <label className="col-4 col-form-label">
                  Auth Level ({this.state.Authlevel}/5)
                </label>
                <div className="col-8 col-lg-10">
                  <input
                    type="range"
                    min="1"
                    max="5"
                    className="form-control "
                    name="Authlevel"
                    value={this.state.Authlevel}
                    onChange={(e) => this.handleChange(e)}
                  />
                </div>
              </div>
            </div>
            <hr />
          </div>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Roles Access & Authority</h4>
            </div>
            <div className="card-body">
              {" "}
              <div className="divider">Dashboard & Theme</div>
              <div className="row">
                <div className="col">
                  <label htmlFor="Role">
                    <strong>Dashboard</strong>
                  </label>
                  <div className="row">
                    <div className="col">
                      <label className="custom-control custom-control-lg custom-checkbox">
                        <input
                          className="custom-control-input"
                          type="checkbox"
                          name="dashboard"
                          value="dashboard"
                          onChange={(e) => this.handleChange(e)}
                        />
                        <span className="custom-control-indicator" />
                        <span className="custom-control-description">
                          Dashboard
                        </span>
                      </label>
                    </div>
                    <div className="col">
                      <label className="custom-control custom-control-lg custom-checkbox">
                        <input
                          className="custom-control-input"
                          type="checkbox"
                          name="dashboard"
                          value="POS"
                          onChange={(e) => this.handleChange(e)}
                        />
                        <span className="custom-control-indicator" />
                        <span className="custom-control-description">POS</span>
                      </label>
                    </div>
                    <div className="col">
                      <label className="custom-control custom-control-lg custom-checkbox">
                        <input
                          className="custom-control-input"
                          type="checkbox"
                          name="dashboard"
                          value="Kitchen"
                          onChange={(e) => this.handleChange(e)}
                        />
                        <span className="custom-control-indicator" />
                        <span className="custom-control-description">
                          Kitchen
                        </span>
                      </label>
                    </div>
                    <div className="col">
                      <label className="custom-control custom-control-lg custom-checkbox">
                        <input
                          className="custom-control-input"
                          type="checkbox"
                          name="dashboard"
                          value="bar"
                          onChange={(e) => this.handleChange(e)}
                        />
                        <span className="custom-control-indicator" />
                        <span className="custom-control-description">Bar</span>
                      </label>
                    </div>
                    <div className="col">
                      <label className="custom-control custom-control-lg custom-checkbox">
                        <input
                          className="custom-control-input"
                          type="checkbox"
                          name="dashboard"
                          value="cake room"
                          onChange={(e) => this.handleChange(e)}
                        />
                        <span className="custom-control-indicator" />
                        <span className="custom-control-description">
                          Cake Room
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <label htmlFor="Role">
                    <strong>Default Theme</strong>
                  </label>
                  <div className="row">
                    <div className="col">
                      <label className="custom-control custom-control-lg custom-checkbox">
                        <input
                          className="custom-control-input"
                          type="radio"
                          name="defaultDash"
                          value="dashboard"
                          checked={
                            this.state.defaultDash === "dashboard"
                              ? true
                              : false
                          }
                          onChange={(e) => this.handleChange(e)}
                        />
                        <span className="custom-control-indicator" />
                        <span className="custom-control-description">
                          Dashboard
                        </span>
                      </label>
                    </div>
                    <div className="col">
                      <label className="custom-control custom-control-lg custom-checkbox">
                        <input
                          className="custom-control-input"
                          type="radio"
                          name="defaultDash"
                          value="POS"
                          checked={
                            this.state.defaultDash === "POS" ? true : false
                          }
                          onChange={(e) => this.handleChange(e)}
                        />
                        <span className="custom-control-indicator" />
                        <span className="custom-control-description">POS</span>
                      </label>
                    </div>
                    <div className="col">
                      <label className="custom-control custom-control-lg custom-checkbox">
                        <input
                          className="custom-control-input"
                          type="radio"
                          name="defaultDash"
                          value="Kitchen"
                          checked={
                            this.state.defaultDash === "Kitchen" ? true : false
                          }
                          onChange={(e) => this.handleChange(e)}
                        />
                        <span className="custom-control-indicator" />
                        <span className="custom-control-description">
                          Kitchen
                        </span>
                      </label>
                    </div>
                    <div className="col">
                      <label className="custom-control custom-control-lg custom-checkbox">
                        <input
                          className="custom-control-input"
                          type="radio"
                          name="defaultDash"
                          value="bar"
                          checked={
                            this.state.defaultDash === "bar" ? true : false
                          }
                          onChange={(e) => this.handleChange(e)}
                        />
                        <span className="custom-control-indicator" />
                        <span className="custom-control-description">Bar</span>
                      </label>
                    </div>
                    <div className="col">
                      <label className="custom-control custom-control-lg custom-checkbox">
                        <input
                          className="custom-control-input"
                          type="radio"
                          name="defaultDash"
                          value="cake room"
                          checked={
                            this.state.defaultDash === "cakeroom" ? true : false
                          }
                          onChange={(e) => this.handleChange(e)}
                        />
                        <span className="custom-control-indicator" />
                        <span className="custom-control-description">
                          Cake Room
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="divider">Actions</div>
              <div className="row">
                <div className="col">
                  <label className="custom-control custom-control-lg custom-checkbox">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      value={1}
                      name="post"
                      onChange={(e) => this.handleChange(e)}
                    />
                    <span className="custom-control-indicator" />
                    <span className="custom-control-description">Post</span>
                  </label>
                </div>
                <div className="col">
                  <label className="custom-control custom-control-lg custom-checkbox">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      value={1}
                      name="edit"
                      onChange={(e) => this.handleChange(e)}
                    />
                    <span className="custom-control-indicator" />
                    <span className="custom-control-description">Edit</span>
                  </label>
                </div>
                <div className="col">
                  <label className="custom-control custom-control-lg custom-checkbox">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      value={1}
                      name="delete"
                      onChange={(e) => this.handleChange(e)}
                    />
                    <span className="custom-control-indicator" />
                    <span className="custom-control-description">Delete</span>
                  </label>
                </div>
                <div className="col">
                  <label className="custom-control custom-control-lg custom-checkbox">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      value={1}
                      name="view"
                      onChange={(e) => this.handleChange(e)}
                    />
                    <span className="custom-control-indicator" />
                    <span className="custom-control-description">View</span>
                  </label>
                </div>
                <div className="col">
                  <label className="custom-control custom-control-lg custom-checkbox">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      value={1}
                      name="approve"
                      onChange={(e) => this.handleChange(e)}
                    />
                    <span className="custom-control-indicator" />
                    <span className="custom-control-description">Approve</span>
                  </label>
                </div>
                <div className="col">
                  <label className="custom-control custom-control-lg custom-checkbox">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      value={1}
                      name="print"
                      onChange={(e) => this.handleChange(e)}
                    />
                    <span className="custom-control-indicator" />
                    <span className="custom-control-description">Print</span>
                  </label>
                </div>
                <div className="col">
                  <label className="custom-control custom-control-lg custom-checkbox">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      value={1}
                      name="export"
                      onClick={(e) => this.handleChange(e)}
                    />
                    <span className="custom-control-indicator" />
                    <span className="custom-control-description">Export</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <Accordion defaultActiveKey="0">
            <Card>
              <Card.Header>
                <CustomToggle eventKey="0">
                  <h4 className="col card-title">Menus & Permission</h4>
                </CustomToggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  <div className="row d-flex">
                    {menuDatas.map((menu, index) => (
                      <div className="col  pb-20" key={index}>
                        <h5>{menu.name}</h5>
                        <ul className="nav nav-pills flex-column">
                          {menu.submenu.map((sub, idx) => (
                            <li key={idx} className="nav-item">
                              <label className="custom-control no-border custom-control-lg custom-checkbox">
                                <input
                                  className="custom-control-input"
                                  type="checkbox"
                                  name="all"
                                  onChange={(e) =>
                                    this.handleChangePermission(
                                      menu.id,
                                      sub.id,
                                      e
                                    )
                                  }
                                />
                                <span className="custom-control-description">
                                  {sub.name}
                                </span>
                                <span className="custom-control-indicator" />
                              </label>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                  {/* {menuDatas.map((menu, index) => (
                    <table className="table table-sm" key={index}>
                      <thead className="thead-light">
                        <tr>
                          <th width="250">
                            <strong>{menu.name}</strong>
                            {/* <input type="checkbox" name="submenu" /> 
                          </th>
                          <th scope="col">View</th>
                          <th scope="col">Edit</th>
                          <th scope="col">Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {menu.submenu.map((sub, idx) => (
                          <tr key={idx}>
                            <td className="col">
                              {sub.name}
                              <span>
                                <input
                                  type="checkbox"
                                  name="all"
                                  onChange={(e) =>
                                    this.handleChangePermission(
                                      menu.id,
                                      sub.id,
                                      e
                                    )
                                  }
                                />
                              </span>
                            </td>
                            <td>
                              <input type="checkbox" name="view" value="view" />
                            </td>
                            <td>
                              <input type="checkbox" name="edit" />
                            </td>
                            <td>
                              <input type="checkbox" name="del" />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ))} */}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
          <button
            type="submit"
            className="btn btn-primary w-100"
            disabled={this.state.btnDisable}
          >
            Submit
          </button>
        </form>
      </div>
    );
  }
}
